import { USER_ID } from "@/constants/common";
import Cookies from "js-cookie";

export const generateId = () =>
  (
    Math.random().toString(36).substring(4) +
    Math.random().toString(36).substring(4)
  ).slice(0, 16);

export const getUserId = () => {
  const storedId = Cookies.get(USER_ID);

  if (storedId) return storedId;

  const generatedId = generateId();

  Cookies.set(USER_ID, generatedId);

  return generatedId;
};
